import { LockIcon as PhosphorLockIcon } from "@phosphor-icons/react/dist/ssr/Lock";

import { createAppIcon } from "@/components/createAppIcon";

export const LockIcon = /* @__PURE__ */ createAppIcon(PhosphorLockIcon);
